import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import NotificationsV2 from '../notificationsV2';
import { pathForScreen } from '../components/PushNotifications';
import { cancel } from '../services/notifications';
import AfterHeader from '../components/AfterHeader';
import { Loader } from 'react-feather';
import TimeAgo from 'timeago-react';
import * as timeago from 'timeago.js';
import es from 'timeago.js/lib/lang/es';

timeago.register('es', es);

const Notifications = (props) => {
    const [notifications, setNotifications] = useState([]);
    // available: the brand registers web endpoints and this browser supports push.
    // permission: authorized | denied | unknown (never asked).
    const [push, setPush] = useState({ available: false, permission: 'unknown' });
    const [loading, setLoading] = useState(true);
    const history = useHistory();

    useEffect(() => {
        let active = true;

        const getData = async () => {
            try {
                // V2 inbox when the brand delivers with FCM, V1 otherwise.
                const res = await NotificationsV2.inbox.listNotifications();
                if (active) {
                    setNotifications(res?.notifications || []);
                }
            } catch (err) {
                console.log(err);
            } finally {
                if (active) {
                    setLoading(false);
                }
            }
        };
        getData();
        NotificationsV2.getPushAvailability().then(availability => {
            if (active) {
                setPush(availability);
            }
        });

        document.title = 'Grisino Fan - Notificaciones';
        return () => {
            active = false;
            if (cancel) {
                cancel();
            }
        };
    }, []);

    const markAllAsRead = async () => {
        try {
            await NotificationsV2.inbox.markAllNotificationsRead(notifications.map(a => a._id));

            const notif = [...notifications]
            notif.forEach(el => { el.read = true })
            setNotifications(notif)
            props.setUnread(0)
            return true;
        } catch (err) {
            console.log(err);
            return false;
        }
    };

    const read = async (id) => {
        try {
            await NotificationsV2.inbox.markNotificationsRead([id])
            
            const notif = [...notifications]
            notif.forEach(el => {
                if (el._id === id) {
                    el.read = true
                }
            })
            
            setNotifications(notif)
            if(props.unread > 0){
                props.setUnread(props.unread - 1)
            }
        } catch (err) {

        }
    }

    const checkAllBtn = () => {
        return (
            <button className={`btn btn-lg btn-primary ${!props.unread ? "disabled" : ""}`} cursor='pointer' onClick={markAllAsRead} >Marcar todos como leidos</button>
        )
    }

    // From the button only: the browser asks for a user action.
    const askPermission = async () => {
        const permission = await NotificationsV2.requestPermission();
        setPush(state => ({ ...state, permission }));
    };

    // Opening from the inbox reads it and follows its action; a link opens in a new tab by itself.
    const open = (notif) => {
        if (!notif.read) {
            read(notif._id);
        }
        if (notif.type === 'promo' && notif.promo?._id) {
            history.push(`/promo/${encodeURIComponent(notif.promo._id)}`);
        }
        if (notif.type === 'screen' && notif.screen) {
            const path = pathForScreen(notif.screen);
            if (path !== null) {
                history.push(path);
            }
        }
    };

    return (
        <div>
            <AfterHeader text="Notificaciones" small={"Enterate de todas las novedades"} button={checkAllBtn} />
            <div className="container-fluid px-0">
                <div className="row p-md-5 p-3">
                    {
                        push.available && push.permission !== 'authorized' &&
                        <div className="col-12">
                            <div className="card mb-4 rounded-12 shadow border border-gray-50 d-flex flex-row p-3 align-items-center justify-content-between" style={{ backgroundColor: '#E8000073' }}>
                                {push.permission === 'denied' ? (
                                    <p className="text-white mb-0">Las notificaciones están bloqueadas en este navegador. Podés habilitarlas desde la configuración del sitio.</p>
                                ) : (
                                    <>
                                        <p className="text-white mb-0">Activá las notificaciones en este dispositivo!</p>
                                        <button className="btn btn-primary" onClick={askPermission}>Activar</button>
                                    </>
                                )}
                            </div>
                        </div>
                    }
                    {loading ? <Loader className="mt-2 mb-0 animate spin" /> :
                        notifications.map(notif => (
                            <div className="col-md-10 col-lg-8 col-xl-6 col-12" key={notif._id}>
                                <div className="card mb-4 rounded-12 shadow border border-gray-50">
                                    <a href={notif?.url} target='_blank' onClick={() => open(notif)} rel="noreferrer">
                                        <div className="card-body p-3 px-xxl-4">
                                            <div className="row align-items-center">
                                                <div className="col pb-1">
                                                    <span className="h5 mb-0">{notif.title}</span>
                                                    <span className="text-gray-700 d-block mb-1 pb-2">{notif.message}</span>
                                                    <TimeAgo className='caption text-muted pb-2' datetime={new Date(notif.start_date)} locale='es' />
                                                </div>
                                                <div className="col-1 mr-2">
                                                    {!notif.read && <div className='custom-blob bg-primary' ></div>}
                                                </div>
                                                <div className="col-2">
                                                    {notif.content?.images?.[0]?.url &&
                                                        <div style={{ aspectRatio: 1 }}>
                                                            <img alt={notif.title} src={notif.content.images[0].url} className="card-img-top" />
                                                        </div>
                                                    }
                                                    {notif.promo?.images?.[0]?.url &&
                                                        <div style={{ aspectRatio: 1 }}>
                                                            <img alt={notif.title} src={notif.promo.images[0].url} className="card-img-top" />
                                                        </div>
                                                    }
                                                    {notif.screen?.images?.[0]?.url &&
                                                        <div style={{ aspectRatio: 1 }}>
                                                            <img alt={notif.title} src={notif.screen.images[0].url} className="card-img-top" />
                                                        </div>
                                                    }
                                                    {notif.data?.image &&
                                                        <div style={{ aspectRatio: 1 }}>
                                                            <img alt={notif.title} src={notif.data.image} className="card-img-top" />
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    )
};

const mapStateToProps = state => ({
    unread: state.notifications,
});

const mapDispatchToProps = dispatch => ({
    setUnread: (unread) => dispatch({ type: 'SET', unread })
 });

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);
